module.exports = __webpack_public_path__ + "static/media/1.aaa768ad.mp3";